import { createAction } from "@reduxjs/toolkit";

export const getAccessControl = createAction("GET_ACCESSCONTROL");
